import React, { useContext } from "react";
import { Route, Redirect } from "react-router-dom";
import { store } from "./store.js";

export default function ProtectedRoute ({ component: Component, ...rest }) {
  const globalState = useContext(store);
  return (<Route {...rest} render={props => (
    globalState.state.authenticate ? (
      <Component {...props}/>
    ) : (
      <Redirect to="/signin" />
    )
  )}/>)
}

